module.exports = __webpack_public_path__ + "static/media/pn.c41603f3.svg";